/**
 * @generated SignedSource<<5b3ec8e8039d4f2cf36d66cf1f70d59a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type pricingGuidanceAbHoc_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useShowPricingGuidance_item">;
  readonly " $fragmentType": "pricingGuidanceAbHoc_item";
};
export type pricingGuidanceAbHoc_item$key = {
  readonly " $data"?: pricingGuidanceAbHoc_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"pricingGuidanceAbHoc_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "pricingGuidanceAbHoc_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowPricingGuidance_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "e07fa23fa2eec905a3b3670a2d7e925e";

export default node;
